/**
 * Segment Configuration (Analytics)
 */
import { AnalyticsBrowser, type Plugin } from '@segment/analytics-next'
import { CONFIG } from './constants'
import { SegmentLogger } from '@/utils/segment/plugins/segment-logger'

const plugins: Plugin[] = []

/* Custom Segment debugging */
if (CONFIG.segmentCustomDebug) {
  plugins.push(SegmentLogger)
}

// Disable Segment for government environments
const options = {
  disable: CONFIG.govEnv,
}

export const segmentAnalytics = AnalyticsBrowser.load({ writeKey: CONFIG.segmentKey, plugins }, options)

/* Original Segment debugging */
segmentAnalytics.debug(CONFIG.segmentDebug)
